/**
 * Generate available time slots for the next 7 days
 * 2-hour blocks from 9am-5pm (9-11am, 11am-1pm, 1-3pm, 3-5pm)
 */
export const generateTimeSlots = () => {
    const timeBlocks = [
        { label: "9:00 AM - 11:00 AM", value: "9-11am" },
        { label: "11:00 AM - 1:00 PM", value: "11am-1pm" },
        { label: "1:00 PM - 3:00 PM", value: "1-3pm" },
        { label: "3:00 PM - 5:00 PM", value: "3-5pm" }
    ];

    const days = [];
    const today = new Date();

    // Generate next 7 days
    for (let i = 0; i < 7; i++) {
        const date = new Date(today);
        date.setDate(today.getDate() + i);

        // Skip weekends
        const dayOfWeek = date.getDay();
        if (dayOfWeek === 0 || dayOfWeek === 6) {
            continue;
        }

        const dayName = date.toLocaleDateString('en-US', { weekday: 'long' });
        const monthDay = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        const fullDate = date.toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });

        days.push({
            date: fullDate,
            label: `${dayName}, ${monthDay}`,
            value: fullDate
        });
    }

    return { days, timeBlocks };
};

/**
 * Format the selected day and time for display/submission
 */
export const formatDateTime = (day, time) => {
    if (!day || !time) return "";

    const date = new Date(day);
    const formattedDate = date.toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    });

    const timeBlock = time.replace(/-/g, ' - ').replace(/am/g, ' AM').replace(/pm/g, ' PM');

    return `${formattedDate} at ${timeBlock}`;
};